import React from 'react';
import { ReactComponent as Calendar } from '../../assets/images/icons/calendarBeta.svg';

export default function CalendarIconBeta(props) {
  return (
    <Calendar className={`icon ${props.className}`} />
  );
}
